export default __webpack_public_path__ + "static/common-sense-14e67227599edc770c13832a040a29e5.svg";